import '.l{width:100%;}.ssr-plugin'
import '.bo{padding-inline:1rem;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.ad{justify-content:center;}.ssr-plugin'
import '.bi{position:sticky;}.ssr-plugin'
import '.bj{top:0px;}.ssr-plugin'
import '.bp{z-index:10;}.ssr-plugin'
import '.bl{background:var(--nav-bg);}.ssr-plugin'
import { type ReactNode } from 'react'
import { styled } from 'inlines'
import { TextLink } from '@app/components/core/link/TextLink'
import useTransform from '@app/util/useTransform'
import { pages } from '@app/util/links'
import { ResponsiveContainer } from '@app/components/layout/ResponsiveContainer'

export type NavBarDesktopProps = {
  userName?: string
  avatar?: string
  isLoading?: boolean
  logo: ReactNode
  children: ReactNode
}

export const NavBarDesktop = ({ logo, children }: NavBarDesktopProps) => {
  const transformStyle = useTransform('center')

  return (
    <nav className="l bo d ad bi bj bp bl"
    >
      <ResponsiveContainer
        style={{
          background: 'var(--nav-bg)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          ...transformStyle,
        }}
      >
        <TextLink
          to={pages.home}
          noHover={true}
          isBold={false}
          textStyle={{ lineHeight: 0 }}
        >
          {logo}
        </TextLink>
        {children}
      </ResponsiveContainer>
    </nav>
  )
}
